import Vue from "vue";
import fa from "vee-validate/dist/locale/fa";
import veeValidate, { Validator } from "vee-validate";

Vue.use(veeValidate);
Validator.localize("fa", fa);
